import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {chain}          from "@Common/utils/fs";
import {arrMapToO}      from "@Common/utils/objects";

import {getStreet}     from "../common/get-street";
import {GradualLoader} from "../gradual-loader";

import {IndividualStreets} from "./individual-streets/individual-streets";

export const AddressBox = ({searchedForm, next: rootNext}) => cs(
    consumeContext("apis"),
    ["searchingIndividualStreet", (_, next) => UseState({
        next,
    })],
    ["excludedState", (_, next) => UseState({
        next,
    })],

    ["addressesLoader", ({apis}, next) => {
        const mapStreetRecordToRequest = (street) => ({
            streetAddress: street.address,
            streetZip: street.zip_code,
        });

        return GradualLoader({
            getKey: ({feed: street, searchForm=undefined}) => {
                return JSON.stringify([
                searchForm ?? searchedForm,
                mapStreetRecordToRequest(street),
            ])},
            fetch: async ({feeds: streets, searchForm=undefined}) => {
                const result = await apis.next.mailing.searchRadiusStreetAddresses({
                    searchForm: searchForm ?? searchedForm,
                    streetAddresses: streets.map(mapStreetRecordToRequest),
                });

                // Add excludedStreetAddresses
                // for (const street in result) {
                //     const addresses = result[street];
                //     for (const address of addresses) {
                //         if (address.display_address === 0) {
                //             scnv(
                //                 data, ["excludedStreetAddresses", street],
                //                 (_) => [..._?.filter((a) => a!==address.address)??[], address.address]
                //             );
                //         }
                //     }
                // }
                
                if (result.result === "failure") {
                    return false;
                }

                return streets.map((s) => result[s.address]);
            },

            next,
        });
    }],

    ({searchingIndividualStreet, addressesLoader, excludedState}) => rootNext({

        searchState: searchingIndividualStreet,
        getInvolvedStreets: (streets) => streets.filter(([streetName, s]) => {
            const street = getStreet(s);
            const key = JSON.stringify([
                searchedForm, {
                    streetAddress: street.address,
                    streetZip: street.zip_code,
                },
            ]);
            return (
                !!excludedState.value?.[streetName]?.length ||
                !!addressesLoader.loadeds?.find((s2) => s2.key === key)?.result?.filter((address) => address.do_not_mail || address.excluded_target)?.length
            )
        }).map(([streetName, s]) => streetName),

        isAddressExcluded: (streetName, address) => excludedState.value?.[streetName]?.includes(address),
        clear: () => searchingIndividualStreet.onChange(null),

        getExcludedAddrCounts: (street) => {
            const key = JSON.stringify([
                searchedForm, {
                    streetAddress: street.address,
                    streetZip: street.zip_code,
                },
            ]);
            return {
                selections: excludedState.value?.[street.address]?.length ?? 0,
                dnm: addressesLoader.loadeds?.find((street) => street.key === key)?.result.filter((address) => address.do_not_mail).length ?? 0,
            };
        },

        loadAddresses: async (streetNames, {getStreetRecord, searchForm=undefined}) => {
            const streets = streetNames.map((street) => getStreet(getStreetRecord(street)));
            const result = await addressesLoader.loadAll({feeds: streets, searchForm});
            if (result.result === "failed") {
                return result;
            }

            return arrMapToO(result, (r) => r.result, (r) => r.feed.address);
        },

        render: ({getStreetRecords}) => (
            searchingIndividualStreet.value && (
                IndividualStreets({
                    excludedAddressesState: excludedState,
                    searching: searchingIndividualStreet.value,
                    loader: addressesLoader,
                    getStreetAddresses: (searching) => {
                        const streetRecords = getStreetRecords();

                        return chain(
                            searching.type === "all" ? (
                                streetRecords
                            ) : (
                                [streetRecords.find((r) => getStreet(r).address === searching.address)]
                            ),
                            (_) => _.map(getStreet),
                        );
                    },
                })
            )
        )
    }),
);

